<template>
  <div class="login">
    <BaseHeaderBar title="" :showCustomerService="false" :showRegister="true" />
    <form class="login-body" @submit.prevent="onSubmit">
      <h3 class="jieshao">Jumlah pinjaman maksimum </h3>
      <h3 class="jieshao jieshao_value">Rp 8.000.000</h3>
      <h3 class="jieshao">Jangka Waktu Pinjaman</h3>
      <h3 class="jieshao jieshao_value">91-360 hari</h3>
      <div class="password-login">Masuk via kata sandi</div>
      <div class="input-block">
        <input v-model.trim="phone" type="tel" autofocus placeholder="Masukkan nomor handphone dengan awalan 08"
          maxlength="13" />
      </div>
      <div class="input-block">
        <input v-model.trim="password" maxlength="8" type="tel" class="password"
          placeholder="Masukkan 8 digit angka password" />
      </div>
      <span class="forget-password" @click="forgetPassword">Lupa Password？</span>
      <button type="button" class="login-btn" @click="onSubmit">
        Login Password
      </button>
      <button type="button" class="SMS-btn" @click="goMessageLogin">
        Masuk dengan SMS
      </button>
    </form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import request from '@/utils/request'
import { validatePhoneNumber, validatePassword } from '@/utils/validator'

export default {
  name: 'Login',
  data () {
    return {
      phone: '',
      password: ''
    }
  },
  methods: {

    forgetPassword () {
      const { query } = this.$route
      this.$router.push({
        path: '/forgetPassword',
        query
      })
    },
    validate () {
      if (!this.phone) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!validatePhoneNumber(this.phone)) {
        Toast('Nomor handphone salah')
        return false
      }
      if (!this.password) {
        Toast('Masukkan 8 digit angka password')
        return false
      }
      if (!validatePassword(this.password)) {
        Toast('Password salah')
        return false
      }
      return true
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const postData = {
        lodrginType: 1,
        usdrerPhone: this.phone,
        usdrerPassword: this.password
      }
      const ixabisoelinye = sessionStorage.getItem('ixabisoelinye')
      if (ixabisoelinye) {
        postData.ixabisoelinye = ixabisoelinye
      }
      request.post('usdrerLogin', postData)
        .then(res => {
          this.$store.commit('recordInfo', {
            type: 'userInfo',
            value: res
          })
          this.addressBook()
          localStorage.setItem('userInfo', JSON.stringify(res))
          this.$router.push('/home1')
        })
        .finally(() => {
          this.flag = false
        })
    },
    goMessageLogin () {
      const { query } = this.$route
      this.$router.push({
        path: '/messageLogin',
        query
      })
    }

  }
}
</script>

<style scoped lang="less">
.login {
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 0 34px;
}

.jieshao {
  font-size: 36px;
  color: #000000;
  margin-bottom: 10px;
  text-align: center;
  color: #333;
}

.jieshao_value {
  margin-bottom: 25px;
  font-size: 56px;
  color: #000;
}

.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 73px 30px 0;

  p {
    font-weight: 600;

    &:first-child {
      font-size: 40px;
      color: #4837bc;
    }

    &:last-child {
      font-size: 32px;
      color: #f9f9f9;
    }
  }
}

.title-block {
  display: flex;
  height: 88px;
  line-height: 88px;

  &>div {
    flex: 1;
    text-align: center;
  }
}

.password-login {
  font-weight: bold;
  font-size: 60px;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}

.message-login {
  border-radius: 10px;
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  background-color: #ffc529;
}

.input-block {
  display: flex;
  align-items: center;
  height: 94px;
  border-radius: 47px;
  background: #ffffff;
  box-shadow: 1px 8px 0px 0px #100c0f;
  border: 2px solid #000000;

  &:nth-child(n + 2) {
    margin-top: 50px;
  }

  input {
    display: block;
    width: 100%;
    height: 88px;
    line-height: 88px;
    padding-left: 20px;
    border: none;
    border-radius: 10px;
    box-sizing: border-box;
    font-size: 32px;
    color: #000000;
    background: none;

    &::placeholder {
      font-weight: 500;
      font-size: 24px;
      color: #000000;
    }

    &:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.password {
  -webkit-text-security: disc;
}

.forget-password {
  float: right;
  margin-bottom: 66px;
  margin-top: 30px;
  font-weight: 500;
  font-size: 32px;
  color: #000;
}

.login-btn {
  .submit-btn;
  margin-top: 29px;
}

.SMS-btn {
  .cancel-btn;
  margin-top: 29px;
}

.footer {
  width: 358px;
  height: 85px;
  margin: 30px auto 25px;
}
</style>
